// Cloudinary URLs for static images used across the website
// These are uploaded once and used in multiple places

export const STATIC_IMAGES = {
  // Logo used in Header, Footer, and as favicon
  logo: "https://res.cloudinary.com/dtslb5uic/image/upload/v1762412530/gym-banner_yzylri.png",
  
  // Head trainer photo
  masterTrainer: "https://res.cloudinary.com/dtslb5uic/image/upload/v1762181569/gym-website/static/master.jpg",
  
  // Background image used in App.js and as fallback
  gymBackground: "https://res.cloudinary.com/dtslb5uic/image/upload/v1762181702/gym-website/static/gymbg.jpg",
};
